import { FolderTree, LogIn } from 'lucide-react'
import { Button } from '@/components/ui'
import { redirectToLogin } from '@/shell/services/auth'

export interface LoginScreenProps {
  /** When true, a prior session expired mid-use rather than never existing.
   *  Slight copy change to explain the disruption. */
  expired?: boolean
}

/**
 * Full-viewport "Log in with Google" screen. Rendered by `<Shell>` when
 * `useCurrentUser()` returns 401. Single button triggers the middleware
 * OAuth flow; the middleware sets the `carla_ui_session` cookie and
 * redirects the browser back to `/`.
 *
 * Sprint 02 W-1.
 */
export function LoginScreen({ expired = false }: LoginScreenProps) {
  return (
    <div className="flex h-dvh items-center justify-center bg-canvas">
      <div className="flex max-w-md flex-col items-center gap-6 rounded-md border border-border-subtle bg-surface px-8 py-10 text-center shadow-sm">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-sm bg-accent text-on-accent">
          <FolderTree size={24} aria-hidden="true" />
        </span>

        <div className="flex flex-col gap-1.5">
          <h1 className="text-xl font-semibold text-primary">SPI Ops</h1>
          <p className="text-sm text-secondary">
            {expired
              ? 'Your session expired. Sign in again to continue.'
              : 'Sign in with your siliconesplus.com Google account.'}
          </p>
        </div>

        <Button variant="primary" size="lg" onClick={redirectToLogin}>
          <LogIn size={14} /> Log in with Google
        </Button>

        <p className="text-2xs text-tertiary">
          @siliconesplus.com accounts only. Access to individual modules
          depends on your assigned role.
        </p>
      </div>
    </div>
  )
}
